// extracted by mini-css-extract-plugin
export var avatar = "_rz-3";
export var avatarContainer = "_rz-2";
export var avatarSpacer = "_rz-5";
export var avatarSpacerContainer = "_rz-4";
export var avatarStackContainer = "_rz-1";
export var bubble = "_rz-0";
export var remainderBubble = "_rz-6";